import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";

const LogoutModal = (props) => {
  // const [userInfo, setUserInfo] = useState(props.userInfo);
  const navigate = useNavigate();
  const logout = () => {
    localStorage.removeItem("userInfo");
    navigate("/", { replace: true });
  };

  return (
    <div>
      <Modal
        show={props.logoutModal}
        onBackdropClick={(reason) => {
          // console.log("reason",reason);
        }}
        onHide={() => props.setLogoutModal(false)}
        centered
        size="sm"
      >
        <Modal.Header
          closeButton
          className="modal-header border-0"
          // style={{ padding: "20px 20px 0px 0px" }}
        ></Modal.Header>
        <Modal.Body
          style={{
            justifyContent: "center",
            display: "flex",
            textAlign: "center",
            padding: "10px",
          }}
        >
          <div>Do you want to logout?</div>
        </Modal.Body>
        <Modal.Footer className="modal-footer border-0">
          <Button
            style={{ background: "#d3d3d385", color: "black", margin: "3px" }}
            onClick={() => props.setLogoutModal(false)}
          >
            Cancel
          </Button>
          <Button
            style={{ background: "#38b2ac8f", color: "black", margin: "3px" }}
            onClick={logout}
          >
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default LogoutModal;
